var _defs, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _rect7, _rect8, _rect9, _circle2, _circle3, _circle4, _circle5, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _circle6, _circle7, _path2, _line, _line2, _polyline, _line3, _line4, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _rect19, _path22, _path23;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFig3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1290.63 1588.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:#0a243a;}.c,.o{fill:#fff;}.d{fill:#10384f;}.e,.k,.m,.p,.q{fill:none;}.e,.o{stroke:#d1d1d1;}.e,.k,.m,.o,.p,.r{stroke-miterlimit:10;}.e,.k,.m{stroke-width:3px;}.f{fill:#d1d1d1;}.g{fill:#23468c;}.h{fill:#638ad6;}.i{fill:#5875af;}.j{fill:#7299e8;}.k{stroke:#999;stroke-dasharray:8 6;}.l{fill:#515151;}.m{stroke:#565656;stroke-dasharray:8 6;}.n{fill:#7c7c7c;}.o{stroke-width:5px;}.p{stroke:#252a35;}.p,.q{stroke-linecap:round;stroke-width:16px;}.q{stroke:#1f2c49;stroke-linejoin:round;}.r{fill:#b1d3e8;stroke:#98b9e2;}.s{fill:#0b133d;}.t{fill:#143559;}.u{fill:#3f6e91;}.v{fill:#294063;}.w{fill:#b7ceea;}.x{fill:#6aa8e5;}.y{fill:#42599b;}.z{fill:#3a6689;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 655.07,
    y1: 18.01,
    x2: 640.74,
    y2: 1277.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#94dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0071e9"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M46.29,376.1c11.77-42.05,40.36-95.67,63.7-113.33s70.65-58,136.24-44.15,143.82,29.64,200.58,22.71,150.76-29,198.06-121.74S749,14.25,790.58,14.88s155.16,0,260.5,104.08S1256.7,387,1271.21,477.23s4.42,120.47,0,135.61-17,53-63.07,75.69-108.49,54.88-109.76,117.32,1.27,141.92,12,172.2-5,94.61-17,111.64-25.86,32.17-55.51,27.12-76.95-30.9-105.33-63.07S553.41,1235.4,503.58,1258.1s-75.69,41.63-107.23,36.59S304.26,1243,272.73,1210.8s-18.3-211.94-7.57-271.23S192.62,793.87,151,764.22,79.08,737.73,36.19,627.35,46.29,376.1,46.29,376.1Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 391.31,
    y: 269.08,
    width: 592.91,
    height: 1158.7,
    rx: 48.25,
    ry: 48.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 426,
    y: 329,
    width: 521.63,
    height: 1032.55,
    rx: 23.65,
    ry: 23.65
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 636.25,
    y: 292,
    width: 101.34,
    height: 13.88,
    rx: 6.94,
    ry: 6.94
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 467,
    y: 1037.34,
    width: 439.01,
    height: 131.83,
    rx: 23.34,
    ry: 23.34
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 585.37,
    y: 1081.7,
    width: 298.56,
    height: 14.72,
    rx: 7.36,
    ry: 7.36
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 585.37,
    y: 1117.02,
    width: 193.43,
    height: 14.72,
    rx: 5.92,
    ry: 5.92
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 526.71,
    cy: 1103.25,
    r: 36.22
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 469.1,
    y: 1201.33,
    width: 439.01,
    height: 131.83,
    rx: 23.34,
    ry: 23.34
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 587.47,
    y: 1245.7,
    width: 298.56,
    height: 14.72,
    rx: 7.36,
    ry: 7.36
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 587.47,
    y: 1281.02,
    width: 193.43,
    height: 14.72,
    rx: 5.92,
    ry: 5.92
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 528.81,
    cy: 1267.25,
    r: 36.22
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 529.88,
    cy: 946.87,
    r: 60.15
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "j",
    cx: 686.78,
    cy: 946.87,
    r: 60.15
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "k",
    cx: 843.68,
    cy: 946.87,
    r: 60.15,
    transform: "translate(-422.43 873.9) rotate(-45)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "l",
    x: 469.72,
    y: 760.49,
    width: 436.91,
    height: 14.72,
    rx: 7.36,
    ry: 7.36
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "l",
    x: 469.72,
    y: 831.29,
    width: 349.24,
    height: 14.72,
    rx: 7.36,
    ry: 7.36
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "l",
    x: 469.72,
    y: 795.76,
    width: 436.91,
    height: 14.72,
    rx: 7.36,
    ry: 7.36
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "m",
    x: 466.37,
    y: 440.01,
    width: 440.27,
    height: 286.99,
    rx: 13.25,
    ry: 13.25
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 545.42,
    y: 367.69,
    width: 359.11,
    height: 29.01,
    rx: 14.51,
    ry: 14.51
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "n",
    x: 468.49,
    y: 369.05,
    width: 39.54,
    height: 3.31,
    rx: 1.66,
    ry: 1.66
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "n",
    x: 468.49,
    y: 392.76,
    width: 39.54,
    height: 3.31,
    rx: 1.66,
    ry: 1.66
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "n",
    x: 468.49,
    y: 380.91,
    width: 39.54,
    height: 3.31,
    rx: 1.66,
    ry: 1.66
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "o",
    x: 124.77,
    y: 372.76,
    width: 426.47,
    height: 278.73,
    rx: 8.89,
    ry: 8.89,
    transform: "translate(111.53 -58.16) rotate(11.77)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 338.01,
    cy: 509.12,
    r: 99.55
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 338.01,
    cy: 509.12,
    r: 87.95
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M398,560c-.91-1-5.14-3.42-7-4.57s-9-4.85-20.31-9.88S356.45,537.17,355,535s.21-8.28.44-9.19,2.47-3.07,4-4.34,3.56-4.28,6-6.84,5.57-10.87,5.7-11.12c.49,0,1.89,0,4.4-2.55,5.07-4.48,6.74-14,7-15.22a7,7,0,0,0-.76-4.38c3.72-13.24,2.49-23.16-.78-29.36-3.15-6-11.53-16-26-19.69v-.06l-.9-.17-.9-.21,0,.06c-14.73-2.34-26.41,3.47-31.67,7.68-5.48,4.38-10.57,13-12.45,26.61a7,7,0,0,0-2.44,3.71c-.22,1.23-2.5,10.63.37,16.76,1.26,3.37,2.54,3.93,3,4.09,0,.28-.4,9.16.78,12.47s1.84,6.87,2.74,8.65,2.09,4.66,1.94,5.59-1.1,7.21-3.26,8.59-6.14,3.27-18.54,3.35-20.4.65-22.58.95-7,.85-8.25,1.39a10,10,0,0,1-1.39.56s3.07,10.09,6.26,15.16,10.78,19.13,28.67,30.08a75.83,75.83,0,0,0,13.7,6.53l0,.09a91.68,91.68,0,0,0,23.68,4.93l0-.08a76.19,76.19,0,0,0,15.16-.52c20.78-2.9,33.35-12.75,38.3-16.13s11.8-11.4,11.8-11.4A9.37,9.37,0,0,1,398,560Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "p",
    x1: 184.67,
    y1: 1496.54,
    x2: 110.83,
    y2: 1249.69
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "p",
    x1: 394.46,
    y1: 1497.79,
    x2: 323.5,
    y2: 1250.11
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "q",
    points: "44.6 1497.16 68.48 1408.08 90.15 1327.21 111.04 1249.27 321.19 1249.69 297.43 1328.44 273.13 1408.99 246.03 1498.84"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "q",
    x1: 90.15,
    y1: 1327.21,
    x2: 297.8,
    y2: 1327.21
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "q",
    x1: 68.48,
    y1: 1408.08,
    x2: 273.4,
    y2: 1408.08
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M173.91,618.31c-.84,6.51-4.84,31.53-6.73,37.63s40.37,7.36,40.37-1.68.63-11.77-.84-14.72a43.7,43.7,0,0,1-3.16-11.14c0-1.47,13.67,4.41,22.71,3.36s10.3-32.38,9.67-40.79-8.41-30.9-11.77-33.43-47.94,4.21-47.94,4.21Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M145.63,581.62c0,6.46,2.21,21.29,8.2,27.12s11.51,10.25,13.88,11.2,7.72,5,8.35,4.57-.63-4.89,0-9.3,1.58-12.94,3.31-15.14.79-2.68,0-3.63-5.32-5.25-3.9-8.87,2.43-5.2,4.88-5.32c3.28-.17,6.28,1.1,6.75.94s1.89-3.46,3-5.2S198,567.58,203,565.53s12.14-4.1,17.66-3.31a42.5,42.5,0,0,1,6.78,1.42c.47,0,3.47-2.21,5.36-5.2s5-16.4,5-19.08-11.36-2.37-19.71-2.53a133.33,133.33,0,0,0-20.35.79c-6,.79-17.66,2.53-21.76,3.47s-14.66,6.31-15.45,7.57-2.84,3.78-2.84,4.73.47,9.3.47,9.3a6.62,6.62,0,0,1-2.83,2.21,19.62,19.62,0,0,0-6.47,4.89c-.95,1.42-3,3.94-3.31,5.2S145.63,581.62,145.63,581.62Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M118.82,833c.32,43.53,6.31,183.55,4.42,195.54s-3.42,75.06-2,103.44,2.4,88.94,2.4,88.94,1.52,12.61,9.72,10.09,19.08-.83,19.43-9.86S173.7,1072,177.48,1043.65s10.09-95.25,10.73-90.2,3.15,65,13.87,107.86,38.48,159.58,38.48,159.58,8.2,16.4,13.24,13.24,20.82,12,18.3-12.61-6.94-104.08-6.94-116.69-2.53-76.32-7.57-116.06-6.31-148.23-6.31-155.8S118.82,833,118.82,833Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M167.5,649.84c.45,1,.31,1.9,2.1,3s6.52,3.68,8.09,3.89,5.05,1.26,8.1,1.05,8.51-1.36,10.51-2.52,6.94-4.41,7.67-5.47,1.69-2.1,2.42-2,3.05-.63,6.2,1.15,12.09,10.52,12.3,11c0,0,20.4,53.41,22.5,70.33s5.79,89.61,5.37,104.75,2,64,1,65-134,2-135,0-3.51-98.85-1-126.42,11.78-82.65,21-96.52,13.85-18.77,16.53-20.66S161.25,651.59,167.5,649.84Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M122.76,1214.12c0,2-.32,24-.32,25.21s0,3.79,2.84,3.79h67.17c2.53,0,1.48-5.47,0-6.42s-10.19-.94-16.29-5-22-16.4-23-17S131.76,1217.12,122.76,1214.12Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M240.09,1215.12c-.1,1.57,0,24.91,0,25.75s.53,2.32,2.73,2.42,78.32.42,78.32.42.11-2.73,0-3.78-.73-3.47-2.94-3.58-14.3-3.89-19.55-6.2-15-6.2-18-8.31-7.2-6.72-8.26-6.72Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M226.68,659c1.26-2.21,3.94-4.41,4.1-6s.16-11.83,2.84-14.19,7.1-7.73,9.78-10.09,4.73-8.36,6.46-8.83,4.89-1.58,3.31,2.52-5.2,8.83-4.41,11.51,1.26,3.94,3.62,4.1a30.83,30.83,0,0,1,6,1.17c.79.25,33.9,7.19,33.9,7.19s-18.13,7.25-22.08,9.3-10.72,5.84-12,6.15-4.73-.16-5.36,1.1-5.21,6.63-5.84,7.73S226.68,659,226.68,659Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M237.4,714.39c5.37,9.46,39.58,43.05,44.63,46.52s9.62,8.2,13.88,6.62,15.45-9.14,21.76-16.87,21.76-26.81,27.44-39.74,11-22.7,11.66-24.12,8.52-3.95,11.83-5.21,15.3-6.31,16.24-6.94,1-1.89,2.53-2S402.66,669,402.66,669s-25.23-5.21-26.33-5.36-6.94-.79-10.88-1-7.57-1.89-8-2.68-3-5.21-1.74-7.41,4.57-5.84,4.89-6.63,1.1-4.41-.16-4.88-6.31,1.14-7.73,4c0,0-6.93,8.1-8.35,10.38s-4.89,8.36-5.29,10-.31,7.57-1,9.93-16.79,27-21.6,33.12-16.64,25.23-18.37,26-8.2-7.89-8.84-8.84S272,698.46,267.6,694.29,237.4,714.39,237.4,714.39Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M253.76,735.12c.63,0,11.05-8.22,15-12s11.31-14.37,11-15S260.11,681,255.7,676.7s-13.41-11.82-18.61-14.82-17.87-11.24-24.33-10.76-1.58,4-3,5-1.53,7.5-2,10-.32,9.78,1.26,14,6.31,14.83,10.41,20.34S253.76,735.12,253.76,735.12Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M847,1350.94c9.46,36,18.92,76.64,19.55,86.73s2.53-21.44,2.53-21.44S852.72,1333,847,1324.45l-5.68-8.51Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M773.66,1372c9,5.68,28.39,16.61,47.52,15.14s34.48-3.79,45.41-11.57,30.07-28.38,33.43-38.26,7.78-26.28,7.57-30.7-1.26-12.19-4.62-14.51-9.46-5.67-19.77-6.3-15.56-.63-18.92-2.11-7.78-5.67-7.78-13,3.58-20,6.52-25,8.2-9.67,4.41-14.51-6.93-4.83-15.34-2.31-16.61,5.89-26.29,5.47-26.7-4.82-30.06-7.14-9-4.74-12.72-3.06-7,7.36-5.57,11.88,4.52,20.71,4.31,23.86-4.1,18.29-10.62,23.34-14.19,11.14-21.45,14.72-5.67,11.14,2,13.14,21.45,6.94,27.54,8.41,20.08,2.84,24,5.46,10.3,8.2-1.47,12.41a273,273,0,0,0-30,13.35c-3.26,1.79-12.51,7.46-8.62,12.09S773.66,1372,773.66,1372Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M936,1367.34c2.73,2.74,18.5,20.4,32.16,24.39s33.22,9.68,55.09,2.11,33.64-15.77,35.11-22.29,3.16-12.2-3.36-17.66-17.87-13-19.34-16.19-3.37-14.93,4.41-18.29,28.81-13.88,30.7-15.77,10.51-8,7.15-19.77-9.47-26.7-18.51-33.43-23.54-17.24-45.2-14.92-38.27,16-41.42,18.71-10.2,12.93-10,18.19,4.5,17.93,7.41,24.28c3.16,6.89-5.2,21.24-11.51,23.76s-23.12,5.25-25.65,6.31-15.56,7.56-8.83,21.23S936,1367.34,936,1367.34Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M934.71,1416.75c5.47-10.3,29.44-55.71,33.64-58.24s-6.09,22.71-8,25.44-17.67,27.34-18.09,32.8S934.71,1416.75,934.71,1416.75Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M898.92,1414.65c-1.42-23.49-1.74-57.4,12.14-107.86s26.81-94.77,30.28-103.28,6.15-4.42,3.47,4.1-18.61,61.65-20.66,71.27-15.45,59.29-17.35,73.48-4.41,56-2.83,61.34S898.92,1414.65,898.92,1414.65Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M904.2,1367.42c1.12,0,3,1.66,10.17,0s20.66-4.25,27.44-10.48,12.08-12.45,13.42-16.31,2.07-12.79,1.88-13c-.36-.42-8.92-.19-12.45,1.07s-11.84,4.13-16.8,7.36-10.65,9.62-15.14,15.3S904.2,1367.42,904.2,1367.42Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M922.08,1278.35c1.1.21,2.64,2.18,10,1.9s21.09-.33,28.92-5.18,14.19-10,16.22-13.51,4.44-12.18,4.29-12.44c-.28-.48-8.73-1.85-12.43-1.27s-12.4,1.84-17.89,4.09-12.25,7.46-17.73,12.2S922.08,1278.35,922.08,1278.35Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M919.93,1278.6c-1-.56-3.62,0-9.41-5.18s-16.95-14.46-20-23.66-4.85-17.64-4.12-21.88,4.58-12.88,4.88-13c.54-.2,8.34,4.37,11,7.34s8.85,9.84,11.8,15.35,5,14.31,6.23,21.84S919.93,1278.6,919.93,1278.6Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M901.77,1365.39c-1.08-.34-3.44.75-9.84-3.16s-18.58-10.76-23.11-19.2-7.61-16.4-7.64-20.74,2.17-13.65,2.44-13.82c.48-.32,8.68,2.58,11.68,5s10.1,7.88,13.85,12.71,7.15,13.09,9.64,20.25S901.77,1365.39,901.77,1365.39Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M941,1208.11c1.06-.38,3.43.55,9.66-3.54s18.13-11.28,22.38-19.64,7.1-16.17,7-20.35-2.53-13-2.8-13.18c-.49-.28-8.53,2.92-11.45,5.37s-9.79,8.09-13.37,12.92-6.73,13-9,20S941,1208.11,941,1208.11Z"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "z",
    x: 825.17,
    y: 1412.76,
    width: 172.41,
    height: 41,
    rx: 19.71,
    ry: 19.71
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M951,1573.6h-83.8a6.89,6.89,0,0,1-6.87-6.88L829.76,1445.4c0-3.78,33.62-5.73,37.4-5.73H951c3.79,0,41.8,2.89,41.8,6.68l-34.92,120.37A6.89,6.89,0,0,1,951,1573.6Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M164.76,653.12c-20,0-41.92,7.29-48,15-3.41,4.31-4.57,30-4,34,1,7,8.39,64.49,12,66s15-32.38,22.55-39.67S164.76,653.12,164.76,653.12Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFig3);
export default __webpack_public_path__ + "static/media/fig3.5a1153e764ce06369fb857c69c330016.svg";
export { ForwardRef as ReactComponent };